import { CheckCircle2, CircleDashed, FileText, XCircle } from "lucide-react";
import {
  VERIFAST_STATUS_BADGE_CLASS,
  type VerifastStatusBadgeVariant,
} from "../../utils/verifastStatusBadge";

type VerifastIdentityStatusBadgeProps = {
  variant: VerifastStatusBadgeVariant;
  label: string;
  testId?: string;
};

const ICON_CLASS: Record<VerifastStatusBadgeVariant, string> = {
  complete: "text-emerald-600",
  failed: "text-rose-600",
  neutral: "text-slate-400",
  info: "text-sky-600",
};

export function VerifastIdentityStatusBadge({
  variant,
  label,
  testId,
}: VerifastIdentityStatusBadgeProps) {
  const Icon =
    variant === "complete"
      ? CheckCircle2
      : variant === "failed"
        ? XCircle
        : variant === "info"
          ? FileText
          : CircleDashed;

  return (
    <div className="mt-2 inline-flex min-h-[28px] items-center gap-2" data-testid={testId}>
      <Icon className={`h-5 w-5 shrink-0 ${ICON_CLASS[variant]}`} aria-hidden />
      <span className={VERIFAST_STATUS_BADGE_CLASS[variant]}>{label}</span>
    </div>
  );
}
